import {ISubmissionProps} from '@/containers/FdcMilanoVolunteers/resources/submission';

export const getIndicators = (submissions: ISubmissionProps[]) => {
    const values = {
        total: 0,
        training: 0,
    }

    submissions.forEach(submission => {
        values.total++;

        if (submission.domanda1_0 && submission.domanda1_1) {
            values.training++;
        }
    })

    if (values.total > 0) {
        return Number((values.training / values.total * 100).toFixed(2));
    }

    return 0;
}